import { render, staticRenderFns } from "./Resultats.vue?vue&type=template&id=439b623a&"
import script from "./Resultats.vue?vue&type=script&lang=js&"
export * from "./Resultats.vue?vue&type=script&lang=js&"
import style0 from "./Resultats.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports